module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXBAMAAACVNSCVAAAAMFBMVEUAAADN0d/P09/N0d/N0d/M0N/O1OHM0d/N0N/Pz9/Pz8/M0d/P0d/M0N/N0d/N0d/5wCUeAAAAD3RSTlMA3x9/788vX58QEG9fn48JGIVyAAAAsElEQVQY012QPQ4BURSFT4h/lUaJHai0Oi0tDYWehAXYAY1eo7cTdiKCkAif3JlkZu77mvdy8uW9e67WTTksaLF0UYmHhgxctuCmM4+ZUopDXqpBQylzOEl9bu0kyrW4S8pnxQ50pUg8eE0qw8RpxpZnov0Us4eLjCNsFFOZ8rWzOuUd/laAUTCVvbuTF8swlrLiR1cr5Guuoj5+HZjmOGOapx5qRp+BQvK27pBecvsDATdcTln8SO4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/public/downArrowIcon.png
// module id = TQ4f
// module chunks = 0